import script from "./StepLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./StepLocation.vue?vue&type=script&setup=true&lang=js"

import "./StepLocation.vue?vue&type=style&index=0&id=5c82a31a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c82a31a"]])

export default __exports__